
import React, { useState } from "react";
import { Container } from "@mui/material";
import HeaderHelpPage from "../../components/HeaderHelpPage";

// Components
import AllQuickPayment from "./all";

const QuickPayment = ({ userRole }) => {
  return (
    <Container>
      <HeaderHelpPage title="Click&Scan2Pay" description="Allow Oxygen7 user to manage a quick payment." />
      <AllQuickPayment userRole={userRole} />
    </Container>
  );
};

export default QuickPayment;